export enum ModalHome {
  ESTADUAL = "ESTADUAL",
  ABRAPA = "ABRAPA",
  CERTIFICADORA = "CERTIFICADORA",
  BCI = "BCI",
  RESPONSAVEL_ABR = "RESPONSAVEL_ABR",
}
